import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { Datepicker } from './Datepicker.js';
import SvgClock24 from '../../../icons/interface/Clock24.js';
import SvgClock32 from '../../../icons/interface/Clock32.js';

var Timepicker = React__default.forwardRef(function (_a, ref) {
    var options = _a.options, _b = _a.bsSize, bsSize = _b === void 0 ? 'md' : _b, _c = _a.placeholder, placeholder = _c === void 0 ? 'Select time' : _c, props = __rest(_a, ["options", "bsSize", "placeholder"]);
    var ClockIcon = bsSize === 'lg' ? SvgClock32 : SvgClock24;
    return (jsx(Datepicker, __assign({ Icon: ClockIcon }, props, { ref: ref, options: __assign({ allowInput: false, enableTime: true, noCalendar: true, dateFormat: 'h:i K' }, options), placeholder: placeholder, resetOptions: true })));
});
Timepicker.displayName = 'Timepicker';

export { Timepicker };
